// extracted by mini-css-extract-plugin
export default {"label":"InfoItem-module__label--Yaxsw","wrapper":"InfoItem-module__wrapper--siDv7","isInline":"InfoItem-module__isInline--FSUJh"};